<template src="./html/Datatable.html"></template>

<script>
	import swal from 'sweetalert2'
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'

	//import FilterBar from './FilterBar'
	import VueElementLoading from 'vue-element-loading'

	import Create from '@/components/requests/views/Create.vue'
	import Edit from '@/components/requests/views/Edit.vue'
	import Show from '@/components/requests/views/Show.vue'
	import Assigned from '@/components/requests/views/Assigned.vue'
	import FilterBar from './FilterBar'
	import Actions from './Actions'
	import _ from 'lodash'

	export default {
		props: ['isAuth', 'user', 'customer'],
		components: {
			'datatable': Vuetable,
			'pagination-info': VuetablePaginationInfo,
			'pagination': VuetablePagination,

			//'filter-bar': FilterBar,
			'loading': VueElementLoading,
			'edit': Edit,
			'show': Show,
			'create': Create,
			'assigned': Assigned,
			'filter-bar': FilterBar,
			'actions': Actions,
		},
		mounted() {
			this.$events.$on('filterSet', eventData => this.filterSet(eventData))
			this.$events.$on('filterReset', eventData => this.filterReset(eventData))
		},
		data () {
			return {
				perPages: [
					{
						label: 20,
						value: 20,
					},
					{
						label: 50,
						value: 50,
					},
					{
						label: 100,
						value: 100,
					},
					{
						label: 'Todo',
						value: null,
					},
				],
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/requests/datatable',
					loading: true,
					moreParams: {
						filter: {
							text: null,
							allowDate: false,
							date: null,
							customer_id: null,
						},
					},
					page: 100,
					path: '',
					sortOrder: [
						{
							field: 'created_at',
							sortField: 'created_at',
							direction: 'desc',
						},
					],
					options: {
						headers: {
							'Authorization': 'Bearer ' + this.$auth.getToken()
						},
					},
					css: {
						table: {
							sortableIcon: 'fa fa-sort',
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: [
						{
							name: '__slot:id',
							title: this.$platform.setting.number_symbol,
							sortField: 'id',
							sortField: 'id',
						},
						{
							name: '__slot:title',
							title: 'Título',
							sortField: 'title',
						},
						{
							name: '__slot:status',
							title: 'Estado',
							sortField: 'request_status_id',
						},
						{
							name: 'created_at',
							title: 'Fecha',
							sortField: 'created_at',
							callback: function(value) {
								return moment(value).format('DD/MM/YY H:mm')
							},
						},
						{
							name: '__slot:author',
							title: 'Autor',
						},
						{
							name: '__slot:assigned',
							title: 'Agente',
						},
						{
							name: '__slot:printed',
							title: '<i class="fa fa-print" aria-hidden="true"></i>',
						},
						{
							name: '__slot:actions',
							title: '',
						},
					],
				},
			}
		},
		watch: {
			'$route'() {
				this.reload()
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				if(this.customer) {
					this.datatable.moreParams.filter.customer_id = this.customer.id
				}
				this.clearFilter()
			},
			reload() {
				this.$nextTick( () => this.$refs.datatable.reload())
			},
			loading() {
				this.datatable.loading = true
			},
			loaded() {
				this.datatable.loading = false
				this.loadDropdowns()
			},
			onPaginationData (paginationData) {
				this.$refs.paginationInfo.setPaginationData(paginationData)
				this.$refs.pagination.setPaginationData(paginationData)
			},
			onChangePage (page) {
				this.$refs.datatable.changePage(page)
			},
			filterSet: _.debounce(function (filter) {
				this.datatable.moreParams.filter = filter
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			}, 300),
			filterReset(filter) {
				this.datatable.moreParams.filter = filter
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			},
			clearFilter() {
				if(this.customer) {
					this.datatable.moreParams.filter.customer_id = this.customer.id
				} else {
					this.datatable.moreParams.filter.customer_id = null
				}
				this.datatable.moreParams.filter.allowDate = false
				this.datatable.moreParams.filter.date = null
				this.datatable.moreParams.filter.text = null
				this.$router.replace({'query': null})
			},
			//--
			loadDropdowns() {
				$('.table-responsive').on('show.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "inherit" )
				});

				$('.table-responsive').on('hide.bs.dropdown', function () {
					$('.table-responsive').css( "overflow", "auto" )
				})
			},
			goTo(to) {
				var menu = null
				if(this.$route) {
					if(this.$route.meta) {
						if(this.$route.meta.menu) {
							menu = this.$route.meta.menu
						}
					}
				}

				if(menu) {
					if(menu == 'dashboard') {
						var to = '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/' + to
					} else {
						var to =  '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/' + menu + '/' + to
					}
				} else {
					var to =  '/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/' + to
				}

				return to
			},
			//--
			openRequestEdit(request) {
				this.$refs.edit.open(request)
			},
			canBecomeCustomer (request) {
				var can = false
				if(request.data) {
					if(request.data) {
						if(request.data.length) {
							var name = request.data.find(function(element) {
								return element.id == 'name'
							})
							if(name) {
								var length = null
								if(request.customers) {
									if(request.customers.length) {
										length = request.customers.length
									}
								}
								if(!length) {
									can = true
								}
							}
						}
					}
				}
				return can
			},
			addCustomer(request) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: "Se creará un cliente",
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.get('admin/requests/' + request.id + '/add/customer')
							.then(response => {
								that.reload()
								swal({
									'title': response.body.title,
									'text': response.body.text,
									'type': response.body.type,
								})
							}).catch(function(response) {
								that.reload()
								if(response.status = 409) {
									swal({
										'title': response.body.title,
										'text': response.body.text,
										'type': response.body.type,
									})
								}
							})
						})
					}
				}]).catch(swal.noop)
			},
			addBudget(request, customer) {
				var that = this
				var data = {}
				var data = {
					customer_id: customer.id,
					request_id: request.id,
				}
				swal.queue([{
					title: this.$t("messages.attention"),
					text: this.$t("messages.budget_will_be_created"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.post('admin/management/budgets', data)
							.then(response => {
								that.reload()
								that.editOrContinue(response, 'budget')
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			editOrContinue(response, type) {
				var that = this
				swal({
					title: response.body.title,
					text: response.body.text,
					type: response.body.type,
					showCancelButton: true,
					confirmButtonColor: '#2cabe3',
					confirmButtonText: 'Editar',
					cancelButtonText: 'Continuar',
				}).then(function () {
					that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/management/budgets/' + response.body.data.id + '/edit')
				}).catch(swal.noop)
			},
			printedString(data) {
				var title = null
				if(data) {
					if(data.printed_at) {
						title = this.$options.filters.moment(data.printed_at)
						if(data.printer) {
							if(data.printer.profile) {
								title += ' - ' + data.printer.profile.first_name + ' ' + data.printer.profile.last_name
							}
						}
					}
				}
				return title
			},
			openEditRequest(request) {
				this.$refs.edit.open(request)
			},
			openShow(data) {
				this.$refs.show.open(data)
			},
			openEdit(data) {
				this.$refs.edit.open(data)
			},
			destroy (item) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/requests/' + item.id)
							.then(response => {
								that.$refs.datatable.reload()
								swal({
									'title': response.body.title,
									'text': response.body.text,
									'type': response.body.type,
								})
							}).catch(function(response) {
								that.$refs.datatable.reload()
								if(response.status == 409) {
									swal({
										'title': response.body.title,
										'text': response.body.text,
										'type': response.body.type,
									})
								}
							})
						})
					}
				}]).catch(swal.noop)
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/requests/views/Datatable.vue